import { render, staticRenderFns } from "./PageBase.vue?vue&type=template&id=7ec1b9d4&scoped=true"
import script from "./PageBase.vue?vue&type=script&lang=ts"
export * from "./PageBase.vue?vue&type=script&lang=ts"
import style0 from "./PageBase.vue?vue&type=style&index=0&id=7ec1b9d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec1b9d4",
  null
  
)

export default component.exports